import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "border-black relative mb-5 flex w-full border p-2.5 tablet:mb-9" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "flex flex-col pl-2" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { key: 2 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")
  const _component_v_image = _resolveComponent("v-image")
  const _component_cart_qty_picker = _resolveComponent("cart-qty-picker")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "absolute -top-4 -right-2.5 grid aspect-square h-7 place-items-center rounded-full border border-black-20 bg-white",
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.debouncedDelete && _ctx.debouncedDelete(...args)))
    }, [
      _createVNode(_component_v_icon, {
        icon: "close",
        width: 13,
        height: 13,
        color: "#878585"
      })
    ]),
    _createElementVNode("a", {
      href: $props.item.url
    }, [
      _createVNode(_component_v_image, {
        lazyloaded: "",
        image: $props.item.image,
        class: "aspect-cart-item h-full w-24 object-cover"
      }, null, 8, ["image"])
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        href: $props.item.url
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["mb-2 text-lg font-bold leading-6", $data.skeletonClass])
        }, _toDisplayString($props.item.title), 3)
      ], 8, _hoisted_4),
      ($data.properties)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.properties.split(','), (property) => {
              return (_openBlock(), _createElementBlock("li", {
                key: property,
                class: "text-[0.8rem] leading-none opacity-40"
              }, _toDisplayString(property), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", {
          class: _normalizeClass(["text-md font-medium", $data.skeletonClass])
        }, _toDisplayString($options.price), 3),
        ($options.originPrice)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["text-md font-medium", $data.skeletonClass])
            }, _toDisplayString($options.originPrice), 3))
          : _createCommentVNode("", true)
      ]),
      (!$props.item.properties['_FreeGift'])
        ? (_openBlock(), _createBlock(_component_cart_qty_picker, {
            key: $props.item.quantity,
            product: $props.item,
            onIsClicked: $options.toggleSkeleton
          }, null, 8, ["product", "onIsClicked"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, "Free gift"))
    ])
  ]))
}